import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import mac from "../../assests/images/landing-page/macbook.png";
import iphone from "../../assests/images/landing-page/iphone.png";
import ipad from "../../assests/images/landing-page/tab.png";
import eatBits from "../../assests/images/landing-page/eatbitcrowd.png";

import forOwner1 from "../../assests/images/landing-page/block_4.png";
import forOwner2 from "../../assests/images/landing-page/block_5.png";
import forOwner3 from "../../assests/images/landing-page/block_6.png";

import forOwnerLogo1 from "../../assests/images/landing-page/block_7.png";
import forOwnerLogo2 from "../../assests/images/landing-page/block_8.png";
import forOwnerLogo3 from "../../assests/images/landing-page/block_9.png";

import forEmployee1 from "../../assests/images/landing-page/block_10.png";
import forEmployee2 from "../../assests/images/landing-page/block_11.png";
import forEmployee3 from "../../assests/images/landing-page/block_12.png";

import forEmployeeLogo1 from "../../assests/images/landing-page/block_13.png";
import forEmployeeLogo2 from "../../assests/images/landing-page/block_14.png";
import forEmployeeLogo3 from "../../assests/images/landing-page/block_15.png";

import forCustomer1 from "../../assests/images/landing-page/block_16.png";
import forCustomer2 from "../../assests/images/landing-page/block_17.png";
import forCustomer3 from "../../assests/images/landing-page/block_18.png";

import forCustomerLogo1 from "../../assests/images/landing-page/block_19.png";
import forCustomerLogo2 from "../../assests/images/landing-page/block_20.png";
import forCustomerLogo3 from "../../assests/images/landing-page/block_21.png";

import dashboard from "../../assests/images/landing-page/Dashboard opt 11.png";
import dashboardMobile from "../../assests/images/landing-page/Dashboard opt 12.png";

import instaLogo from "../../assests/images/landing-page/insta.png";
import tiktokLogo from "../../assests/images/landing-page/media_1.png";
import facebookLogo from "../../assests/images/landing-page/media_2.png";

import togglenav from "../../assests/images/landing-page/block_3.png";
import loginuser from "../../assests/images/landing-page/Button container.png";
import crossicon from "../../assests/images/landing-page/block_22.png";
import tickicon from "../../assests/images/landing-page/tick.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/pagination";
import "./style.css";

import { API_ENDPOINT, GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { PLANS } from "src/constants/queries";
import { Swiper as SwiperInstance } from "swiper";
import Logo from "../../components/common/Logo";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";

type FeatureTab = "owners" | "employees" | "customers";
type DemoFormState = {
  name: string;
  email: string;
  phone: string;
  restaurantName: string;
  note: string;
};

const MAX_W = "max-w-6xl";

function cn(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(" ");
}

function smoothScrollToId(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
}

function titleCase(s: any) {
  const str = typeof s === "string" ? s : String(s ?? "");
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const LandingPage = () => {
  const currentYear = new Date().getFullYear();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [plans, setPlans] = useState<any[]>([]);
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [featureTab, setFeatureTab] = useState<FeatureTab>("owners");
  const [demoForm, setDemoForm] = useState<DemoFormState>({
    name: "",
    email: "",
    phone: "",
    restaurantName: "",
    note: "",
  });
  const [isSubmittingDemo, setIsSubmittingDemo] = useState(false);
  const [demoSubmitMessage, setDemoSubmitMessage] = useState<string | null>(null);
  const [demoSubmitError, setDemoSubmitError] = useState<string | null>(null);
  const { axBe } = useAxiosInterceptor();

  const swiperRef = useRef<SwiperInstance | null>(null);

  const navItems = useMemo(
    () => [
      { label: "What is EatsBits?", id: "whatIsEatsBits" },
      { label: "Who it’s for", id: "roles" },
      { label: "Product", id: "howItWorks" },
      { label: "Pricing", id: "pricing" },
      { label: "Book a demo", id: "book-a-demo" },
    ],
    []
  );

  const slidesByTab = useMemo(() => {
    const owners = [
      {
        imgSrc: forOwner1,
        logoSrc: forOwnerLogo1,
        title: "Comprehensive Dashboard",
        description: "Manage orders, reservations, and customer interactions from a single interface.",
      },
      {
        imgSrc: forOwner2,
        logoSrc: forOwnerLogo2,
        title: "Analytics and Reporting",
        description: "Gain insights into performance with detailed analytics and reports.",
      },
      {
        imgSrc: forOwner3,
        logoSrc: forOwnerLogo3,
        title: "Restaurant Management",
        description: "Menus, staff scheduling, roles, and operations — streamlined.",
      },
    ];

    const employees = [
      {
        imgSrc: forEmployee1,
        logoSrc: forEmployeeLogo1,
        title: "Order Management",
        description: "Clean workflows for high-volume service.",
      },
      {
        imgSrc: forEmployee2,
        logoSrc: forEmployeeLogo2,
        title: "Table Seating",
        description: "Optimize seating and reservations for speed and accuracy.",
      },
      {
        imgSrc: forEmployee3,
        logoSrc: forEmployeeLogo3,
        title: "Bill Management",
        description: "Accurate billing and faster checkout.",
      },
    ];

    const customers = [
      {
        imgSrc: forCustomer1,
        logoSrc: forCustomerLogo1,
        title: "Discovery",
        description: "Explore restaurants by cuisine, location, and reviews.",
      },
      {
        imgSrc: forCustomer2,
        logoSrc: forCustomerLogo2,
        title: "Ordering",
        description: "Menus, takeaway, and delivery — seamless flow.",
      },
      {
        imgSrc: forCustomer3,
        logoSrc: forCustomerLogo3,
        title: "Order History",
        description: "Reorder favorites and track history.",
      },
    ];

    return { owners, employees, customers };
  }, []);

  useEffect(() => {
    const fetchPlans = async () => {
      if (!GRAPHQL_ENDPOINT) return;
      try {
        const { data: result } = await axBe.post(GRAPHQL_ENDPOINT, { query: PLANS });
        const p = result?.data?.plans;
        if (Array.isArray(p)) setPlans(p);
      } catch {
        // ignore
      }
    };
    fetchPlans();
  }, [axBe]);

  // ensure page scroll works even if global styles lock body
  useEffect(() => {
    document.documentElement.classList.add("landing-page-route");
    document.body.classList.add("landing-page-route");
    return () => {
      document.documentElement.classList.remove("landing-page-route");
      document.body.classList.remove("landing-page-route");
    };
  }, []);

  useEffect(() => {
    if (!isMenuOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isMenuOpen]);

  const compareModel = useMemo(() => {
    if (!plans?.length) return null;

    const all = Array.from(new Set(plans.flatMap((p: any) => p?.features || []))).filter(Boolean) as string[];

    const toSection = (f: string) => {
      const lower = (f || "").toLowerCase();
      if (lower.includes("support") || lower.includes("help")) return "Support";
      if (lower.includes("fee") || lower.includes("pricing") || (lower.includes("order") && lower.includes("per"))) return "Pricing & fees";
      if (lower.includes("analytics") || lower.includes("report") || lower.includes("insight")) return "Analytics";
      if (lower.includes("table") || lower.includes("order") || lower.includes("menu") || lower.includes("location") || lower.includes("qr"))
        return "Operations";
      if (lower.includes("manage") || lower.includes("permission") || lower.includes("role") || lower.includes("staff") || lower.includes("dashboard"))
        return "Management";
      return "Core features";
    };

    const bySection: Record<string, string[]> = {
      "Core features": [],
      Operations: [],
      Analytics: [],
      Management: [],
      Support: [],
      "Pricing & fees": [],
    };

    all.forEach((f) => {
      const sec = toSection(f);
      (bySection[sec] || bySection["Core features"]).push(f);
    });

    const order = ["Core features", "Operations", "Analytics", "Management", "Support", "Pricing & fees"];
    const sections = order
      .map((title) => ({ title, features: (bySection[title] || []).slice().sort() }))
      .filter((s) => s.features.length);

    return { sections };
  }, [plans]);

  const matrixColumnTemplate = `minmax(180px,1fr) ${plans.map(() => "minmax(96px,120px)").join(" ")}`;
  const canSubmitDemo =
    demoForm.name.trim() &&
    demoForm.email.trim() &&
    demoForm.phone.trim() &&
    demoForm.restaurantName.trim();

  const handleDemoFieldChange = (field: keyof DemoFormState, value: string) => {
    setDemoForm((prev) => ({ ...prev, [field]: value }));
    if (demoSubmitMessage) setDemoSubmitMessage(null);
    if (demoSubmitError) setDemoSubmitError(null);
  };

  const submitDemoRequest = async () => {
    if (!canSubmitDemo || !API_ENDPOINT) {
      return;
    }

    setIsSubmittingDemo(true);
    setDemoSubmitMessage(null);
    setDemoSubmitError(null);

    try {
      await axBe.post(
        `${API_ENDPOINT}auth/public-email`,
        {
          name: demoForm.name,
          email: demoForm.email,
          phone: demoForm.phone,
          subject: "New demo request from EatsBits landing page",
          content: [
            `Restaurant name: ${demoForm.restaurantName}`,
            demoForm.note ? `Notes: ${demoForm.note}` : "",
          ]
            .filter(Boolean)
            .join("\n"),
        },
        {
          meta: {
            suppressAuthErrorToast: true,
            skipAuthRefresh: true,
          },
        }
      );

      setDemoSubmitMessage("Thanks. We'll reach out within 24 hours.");
      setDemoForm({
        name: "",
        email: "",
        phone: "",
        restaurantName: "",
        note: "",
      });
    } catch (error) {
      setDemoSubmitError("We couldn't send your request right now. Please try again.");
    } finally {
      setIsSubmittingDemo(false);
    }
  };

  return (
    <div
      className={cn(
        "landing-page-root min-h-screen bg-white text-slate-900",
        /* Reserve space when header is fixed on small screens (sticky is unreliable inside #root/flex) */
        "max-lg:pt-[calc(76px+env(safe-area-inset-top,0px))] lg:pt-0"
      )}
    >
      {/* NAV — fixed below lg for reliable mobile stickiness; sticky from lg up */}
      <header
        className={cn(
          "z-50 border-b border-slate-100 bg-white",
          "max-lg:fixed max-lg:left-0 max-lg:right-0 max-lg:top-0",
          "lg:sticky lg:top-0"
        )}
      >
        <div className="pt-[env(safe-area-inset-top,0px)]">
          <div className={cn("mx-auto", MAX_W, "px-4 md:px-8")}>
            <div className="h-[76px] flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Logo />
              <span className="text-lg md:text-xl font-semibold tracking-tight">EatsBits</span>
            </div>

            <nav className="hidden lg:flex items-center gap-7 text-sm text-slate-600">
              {navItems.map((item) => (
                <button key={item.id} onClick={() => smoothScrollToId(item.id)} className="hover:text-slate-900 transition">
                  {item.label}
                </button>
              ))}
            </nav>

            <div className="hidden lg:flex items-center gap-3">
              <Link to="/login" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition">
                Login
              </Link>
              <Link
                to="/Sign-up"
                className="inline-flex items-center justify-center h-10 px-4 rounded-xl bg-[#e86a4d] text-white text-sm font-medium hover:bg-[#d45f44] transition shadow-sm"
              >
                Sign Up
              </Link>
            </div>

            <div className="flex lg:hidden items-center gap-1 shrink-0">
              <button
                type="button"
                onClick={() => setMenuOpen(true)}
                className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-lg p-1 hover:bg-slate-100"
                aria-label="Open menu"
              >
                <img className="h-10 w-10 object-contain" src={togglenav} alt="" />
              </button>
              <Link
                to="/login"
                className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-lg p-1 hover:bg-slate-100"
                aria-label="Login"
              >
                <img className="h-10 w-10 object-contain" src={loginuser} alt="" />
              </Link>
            </div>
          </div>
        </div>
        </div>
      </header>

      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -top-[260px] left-1/2 -translate-x-1/2 h-[520px] w-[980px] rounded-full bg-slate-200/55 blur-3xl" />
          <div className="absolute top-[120px] left-1/2 -translate-x-1/2 h-[260px] w-[680px] rounded-full bg-orange-100/60 blur-3xl" />
        </div>

        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 pt-24 pb-16")}>
          <div className="text-center max-w-4xl mx-auto">
            <p className="text-4xl md:text-6xl font-semibold tracking-tight leading-[1.05]">
              Unified operations platform for modern restaurants.
            </p>
            <p className="text-slate-600 mt-6 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
              All restaurant operations. One system.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center items-center">
              <Link
                to="/Sign-up"
                className="w-full sm:w-auto min-w-[180px] h-12 px-6 rounded-xl bg-[#e86a4d] text-white font-medium inline-flex items-center justify-center hover:bg-[#d45f44] transition shadow-sm"
              >
                Get Started
              </Link>
              <button
                onClick={() => smoothScrollToId("book-a-demo")}
                className="w-full sm:w-auto min-w-[180px] h-12 px-6 rounded-xl border border-slate-300 bg-white text-slate-900 font-medium inline-flex items-center justify-center hover:bg-slate-50 transition"
              >
                Request demo
              </button>
            </div>

            <p className="mt-6 text-sm text-slate-500">
              Trusted by restaurants across Texas
            </p>
            <div className="mt-1 text-sm text-slate-400">
              No credit card required · Setup in minutes · Multi-location ready
            </div>
          </div>

          <div className="relative mt-14 md:mt-16">
            <div className="relative mx-auto h-[240px] md:h-[520px] w-full">
              <div className="absolute inset-x-0 bottom-0 flex justify-center">
                <img src={mac} alt="Mac" className="w-[92%] md:w-[78%] drop-shadow-[0_30px_80px_-30px_rgba(0,0,0,0.30)]" />
              </div>
              <img
                src={iphone}
                alt="iPhone"
                className="absolute bottom-0 left-[2%] md:left-[8%] w-[26%] md:w-[18%] drop-shadow-[0_20px_60px_-25px_rgba(0,0,0,0.25)]"
              />
              <img
                src={ipad}
                alt="iPad"
                className="absolute bottom-0 right-[2%] md:right-[8%] w-[30%] md:w-[20%] drop-shadow-[0_20px_60px_-25px_rgba(0,0,0,0.25)]"
              />
            </div>
          </div>
        </div>

        <div className="bg-slate-900">
          <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 py-4 flex items-center justify-between")}>
            <p className="text-slate-300 text-sm">Enterprise-grade security · Reliable · Scalable</p>
            <p className="hidden md:block text-slate-400 text-sm">Role-based access · Audit trails · Multi-location ready</p>
          </div>
        </div>
      </section>

      {/* Trust strip — enterprise credibility */}
      <div className="bg-white border-y border-slate-100 py-6">
        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 text-center text-sm text-slate-500")}>
          <p>Trusted by 120+ restaurants across Texas · Multi-location ready · Enterprise secure</p>
          <p className="mt-1 text-slate-400">Serving multi-location restaurants across Houston & Austin</p>
        </div>
      </div>

      {/* WHAT IS */}
      <section id="whatIsEatsBits" className="bg-slate-50">
        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 py-24")}>
          <div className="text-center mb-12 md:mb-16">
            <p className="text-3xl md:text-4xl font-semibold tracking-tight">
              One platform that connects restaurants, staff, and diners
            </p>
            <p className="text-slate-600 mt-4 max-w-2xl mx-auto leading-relaxed">
              Unified workflows across operations, ordering, and discovery — designed to reduce overhead and improve throughput.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 md:gap-12 items-center">
            <div>
              <img
                src={eatBits}
                alt="EatsBits"
                className="w-full h-[240px] md:h-[360px] object-cover rounded-2xl border border-slate-100 shadow-[0_10px_40px_-20px_rgba(0,0,0,0.20)]"
              />
            </div>

            <div className="grid sm:grid-cols-3 gap-4">
              {[
                { top: "+24%", bottom: "Order efficiency" },
                { top: "2 min", bottom: "Avg. setup" },
                { top: "3 roles", bottom: "One platform" },
              ].map((stat) => (
                <div
                  key={stat.top}
                  className="bg-white rounded-2xl border border-slate-100 p-6 text-center shadow-sm hover:shadow-[0_12px_40px_-22px_rgba(0,0,0,0.18)] transition"
                >
                  <div className="text-3xl font-semibold">{stat.top}</div>
                  <div className="text-sm text-slate-600 mt-2">{stat.bottom}</div>
                </div>
              ))}
              <div className="sm:col-span-3 bg-white rounded-2xl border border-slate-100 p-6 shadow-sm">
                <div className="text-sm font-semibold text-slate-900">Operational outcomes</div>
                <div className="text-sm text-slate-600 mt-2 leading-relaxed">
                  Faster order flow, fewer manual steps, consistent staff permissions, and clearer performance visibility.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHO IT'S FOR */}
      <section id="roles" className="bg-white">
        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 py-24")}>
          <div className="text-center mb-12 md:mb-16">
            <p className="text-3xl md:text-4xl font-semibold tracking-tight">Who it’s for</p>
            <p className="text-slate-600 mt-4">One platform, role-specific experiences.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              { title: "Owners", desc: "Run menus, staff, analytics, and multi-location visibility." },
              { title: "Employees", desc: "Manage orders, tables, and bills — faster and cleaner." },
              { title: "Customers", desc: "Discover restaurants and order seamlessly." },
            ].map((card) => (
              <div key={card.title} className="bg-white border border-slate-100 rounded-2xl p-7 shadow-sm">
                <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Role</div>
                <div className="mt-2 text-lg font-semibold">{card.title}</div>
                <div className="mt-3 text-sm text-slate-600 leading-relaxed">{card.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BUILT FOR EVERY ROLE */}
      <section id="howItWorks" className="bg-slate-50">
        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 py-24")}>
          <div className="text-center mb-10 md:mb-14">
            <p className="text-3xl md:text-4xl font-semibold tracking-tight">Built for every role</p>
            <p className="text-slate-600 mt-4">Role-based product views — clean and enterprise.</p>
          </div>

          {/* Tabs — underline on selected (same as billing toggle) */}
          <div className="flex justify-center mb-10">
            <div className="inline-flex items-center gap-6">
              {(["owners", "employees", "customers"] as FeatureTab[]).map((t) => (
                <button
                  key={t}
                  type="button"
                  onClick={() => setFeatureTab(t)}
                  className={cn(
                    "px-5 md:px-6 py-3 text-sm font-medium transition",
                    featureTab === t ? "text-slate-900" : "text-slate-500 hover:text-slate-700"
                  )}
                  style={{
                    borderBottom: featureTab === t ? "2px solid #0f172a" : "2px solid transparent",
                  }}
                >
                  {t === "owners" ? "Owners" : t === "employees" ? "Employees" : "Customers"}
                </button>
              ))}
            </div>
          </div>

          {/* Desktop */}
          <div className="hidden md:grid grid-cols-3 gap-6">
            {(featureTab === "owners"
              ? [
                  { img: forOwner1, title: "Comprehensive Dashboard", desc: "Orders, reservations, and customer interactions in one interface." },
                  { img: forOwner2, title: "Analytics & Reporting", desc: "Performance visibility with reporting that drives decisions." },
                  { img: forOwner3, title: "Restaurant Management", desc: "Menus, staff scheduling, roles, and operations — streamlined." },
                ]
              : featureTab === "employees"
              ? [
                  { img: forEmployee1, title: "Order Management", desc: "Clean workflows for high-volume service." },
                  { img: forEmployee2, title: "Table Seating", desc: "Seating and reservations optimized for speed." },
                  { img: forEmployee3, title: "Bill Management", desc: "Accurate billing and faster checkout." },
                ]
              : [
                  { img: forCustomer1, title: "Discovery", desc: "Explore restaurants by cuisine, location, and reviews." },
                  { img: forCustomer2, title: "Ordering", desc: "Menus, takeaway, and delivery — seamless flow." },
                  { img: forCustomer3, title: "Order History", desc: "Reorder favorites and track history." },
                ]
            ).map((x) => (
              <div key={x.title} className="bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-[0_12px_40px_-30px_rgba(0,0,0,0.18)]">
                <div className="bg-slate-50">
                  <img src={x.img} alt={x.title} className="w-full" />
                </div>
                <div className="p-6">
                  <div className="text-base font-semibold">{x.title}</div>
                  <div className="mt-2 text-sm text-slate-600 leading-relaxed">{x.desc}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile swiper (use slides for current tab) */}
          <div className="md:hidden">
            <Swiper
              onSwiper={(swiper: SwiperInstance) => {
                swiperRef.current = swiper;
              }}
              pagination={{ dynamicBullets: true }}
              modules={[Pagination]}
              onSlideChange={(swiper: SwiperInstance) => setCurrentSlide(swiper.activeIndex)}
              className="mySwiper"
            >
              {slidesByTab[featureTab].map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className="bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-[0_12px_40px_-30px_rgba(0,0,0,0.18)]">
                    <img src={slide.imgSrc} alt={slide.title} className="w-full" />
                    <div className="p-6 text-center">
                      <img src={slide.logoSrc} alt={`${slide.title} logo`} className="mx-auto" />
                      <div className="mt-3 font-semibold">{slide.title}</div>
                      <div className="mt-2 text-sm text-slate-600 leading-relaxed">{slide.description}</div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="flex justify-center mt-4">
              {slidesByTab[featureTab].map((_, index) => (
                <button
                  key={index}
                  className={cn("w-2.5 h-2.5 rounded-full mx-1", currentSlide === index ? "bg-slate-700" : "bg-slate-300")}
                  onClick={() => swiperRef.current?.slideTo(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SCALE */}
      <section className="bg-white">
        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 py-24")}>
          <div className="text-center mb-12 md:mb-16">
            <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Enterprise foundations</div>
            <p className="text-3xl md:text-4xl font-semibold tracking-tight mt-3">Designed for operational scale</p>
            <p className="text-slate-600 mt-4 max-w-2xl mx-auto leading-relaxed">
              Multi-location readiness, reporting, permissions, and integration flexibility.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {[
              { title: "Multi-location dashboards", desc: "Centralized visibility across all locations." },
              { title: "Advanced reporting", desc: "Insights that support data-driven decisions." },
              { title: "Role-based permissions", desc: "Access control that scales with your team." },
              { title: "Integrations", desc: "Connect with tools you already use." },
            ].map((f) => (
              <div key={f.title} className="bg-slate-50 rounded-2xl p-7 shadow-md">
                <div className="text-sm font-semibold">{f.title}</div>
                <div className="mt-2 text-sm text-slate-600 leading-relaxed">{f.desc}</div>
              </div>
            ))}
          </div>

          <div className="mt-10 text-center text-slate-500 text-sm">Secure · Scalable · Reliable</div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="bg-slate-50">
        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 py-24")}>
          <div className="text-center mb-10 md:mb-12">
            <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Early Launch</div>
            <p className="text-3xl md:text-4xl font-semibold tracking-tight mt-3">Founding Partner Program</p>
            <p className="text-slate-600 mt-4 max-w-xl mx-auto leading-relaxed">
              Join EatsBits as an early restaurant partner and help shape the platform around real restaurant operations.
            </p>
          </div>

          {/* Founding partner offer */}
          <div className="mx-auto max-w-4xl">
            <div className="bg-white border border-slate-100 rounded-2xl p-8 md:p-10 shadow-sm hover:shadow-[0_18px_60px_-40px_rgba(0,0,0,0.22)] transition">
              <div className="grid gap-8 md:grid-cols-[minmax(0,1.2fr)_minmax(280px,0.8fr)] md:items-start">
                <div>
                  <div className="text-sm font-semibold text-slate-900">Founding Partner</div>
                  <div className="mt-3 max-w-xl text-sm text-slate-600 leading-relaxed">
                    Built for local restaurants who want to grow together with EatsBits during our early launch stage.
                  </div>

                  <div className="mt-8">
                    <div className="text-5xl font-semibold tracking-tight">$0</div>
                    <div className="text-sm text-slate-600 mt-2">
                      No monthly platform fee for early partner restaurants.
                    </div>
                    <div className="text-xs text-slate-500 mt-3">
                      Payment processing fees may still apply.
                    </div>
                  </div>
                </div>

                <div className="rounded-2xl border border-slate-100 bg-slate-50/70 p-6">
                  <button
                    type="button"
                    onClick={() => smoothScrollToId("book-a-demo")}
                    className="w-full h-11 rounded-xl bg-[#e86a4d] text-white font-medium hover:bg-[#d45f44] transition"
                  >
                    Become a Partner
                  </button>

                  <div className="mt-6">
                    <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-3">Highlights</div>
                    <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-1">
                      {[
                        "Restaurant setup and onboarding",
                        "Menu creation and management",
                        "QR code ordering",
                        "Payment processing",
                        "Kitchen printing support",
                        "Reporting and analytics",
                        "Direct support from founder",
                      ].map((feature, i) => (
                        <div key={i} className="flex items-start gap-2 text-sm text-slate-700">
                          <img src={tickicon} alt="" className="mt-0.5 opacity-60 shrink-0" />
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {compareModel && (
                    <button
                      type="button"
                      onClick={() => smoothScrollToId("feature-matrix")}
                      className="inline-flex mt-6 text-sm font-medium text-slate-700 hover:text-slate-900"
                    >
                      View feature matrix →
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Feature matrix (compact, minimal lines) */}
          {compareModel && (
            <div id="feature-matrix" className="mt-10 md:mt-14 scroll-mt-24 max-w-3xl mx-auto">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">
                <div>
                  <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Feature matrix</div>
                  <h2 className="text-xl md:text-2xl font-semibold mt-2">Compare features</h2>
                  <p className="text-sm text-slate-600 mt-1">See what’s included in each plan.</p>
                </div>
                <button
                  type="button"
                  onClick={() => smoothScrollToId("book-a-demo")}
                  className="shrink-0 inline-flex items-center justify-center h-11 px-6 rounded-xl border border-slate-300 bg-white text-slate-900 font-medium hover:bg-slate-50 transition"
                >
                  Talk to sales
                </button>
              </div>

              <div className="rounded-xl border border-slate-100 bg-white overflow-hidden">
                {/* Header row (compact) */}
                <div
                  className="grid gap-0 px-4 py-3 bg-slate-50 text-sm font-semibold text-slate-900"
                  style={{ gridTemplateColumns: matrixColumnTemplate }}
                >
                  <div>Feature</div>
                  {plans.map((p, i) => (
                    <div key={i} className="text-center truncate">
                      {titleCase(p?.name)}
                    </div>
                  ))}
                </div>

                <div className="px-2 pb-3">
                  {compareModel.sections.map((section) => (
                    <details key={section.title} open className="group mt-3">
                      {/* Compact section header: no divider line */}
                      <summary className="cursor-pointer select-none flex items-center justify-between px-2 py-2">
                        <div className="inline-flex items-center gap-2">
                          <span className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
                            {section.title}
                          </span>
                          <span className="text-[11px] text-slate-400">
                            ({section.features.length})
                          </span>
                        </div>
                        <span className="text-slate-400 group-open:rotate-180 transition text-xs">▾</span>
                      </summary>

                      {/* Compact rows: no per-row borders, use zebra + subtle hover */}
                      <div className="rounded-xl overflow-hidden">
                        {section.features.map((feature, rowIdx) => (
                          <div
                            key={feature}
                            className={cn(
                              "grid items-center",
                              "px-2 py-2 text-sm",
                              rowIdx % 2 === 0 ? "bg-white" : "bg-slate-50/60",
                              "hover:bg-slate-100/70 transition"
                            )}
                            style={{ gridTemplateColumns: matrixColumnTemplate }}
                          >
                            <div className="text-slate-700 pr-2 leading-snug">
                              {feature}
                            </div>

                            {plans.map((p, i) => {
                              const ok = (p?.features || []).includes(feature);
                              return (
                                <div key={i} className="text-center flex justify-center">
                                  {ok ? (
                                    <span className="inline-flex items-center justify-center text-slate-900 font-semibold" aria-label="Included">
                                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </span>
                                  ) : (
                                    <span className="text-slate-300 text-lg">—</span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ))}
                      </div>
                    </details>
                  ))}
                </div>
              </div>

              {/* Mobile hint */}
              <div className="mt-3 text-xs text-slate-500 md:hidden">
                Tip: swipe horizontally if needed.
              </div>
            </div>
          )}
        </div>
      </section>

      {/* SEE IN ACTION — big confident screenshot, tight to CTA (enterprise polish) */}
      <section className="bg-white">
        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 pt-20 pb-16")}>
          <div className="text-center mb-6">
            <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Demo</div>
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mt-3">See EatsBits in action</h2>
            <p className="text-slate-600 mt-4 max-w-xl mx-auto">Book a 15-minute demo. We’ll show workflows, roles, and reporting.</p>
          </div>

          <div className="flex flex-col items-center">
            {/* Desktop: image with CTA anchored close below; minimal shadow, button feels attached */}
            <div className="relative w-full md:w-[90%] mx-auto hidden md:block pb-10">
              <img
                src={dashboard}
                alt="EatsBits dashboard"
                className="w-full rounded-2xl shadow-sm"
              />
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 z-10">
                <button
                  type="button"
                  onClick={() => smoothScrollToId("book-a-demo")}
                  className="see-in-action-demo-btn h-12 px-6 rounded-xl font-medium shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg"
                >
                  Request demo
                </button>
              </div>
            </div>

            {/* Mobile: image + button below, tightened */}
            <div className="relative w-full mx-auto md:hidden">
              <img
                src={dashboardMobile}
                alt="EatsBits dashboard"
                className="w-full rounded-2xl shadow-sm"
              />
            </div>
            <button
              type="button"
              onClick={() => smoothScrollToId("book-a-demo")}
              className="see-in-action-demo-btn mt-6 mb-0 h-12 px-6 rounded-xl font-medium shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg md:hidden"
            >
              Request demo
            </button>
          </div>
        </div>
      </section>

      {/* DEMO FORM (FIXED: no green accent clash) */}
      <section id="book-a-demo" className="bg-slate-50 border-t border-slate-100">
        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 py-24")}>
          <div className="grid md:grid-cols-2 gap-10 items-start">
            <div>
              <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Sales</div>
              <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mt-3">Interested in learning more?</h2>
              <p className="text-slate-600 mt-4 leading-relaxed">
                Tell us about your restaurant. We’ll walk you through the best plan and onboarding path.
              </p>

              <div className="mt-6 text-sm text-slate-600">
                Response within 24 hours · No obligation · Built for teams
              </div>
            </div>

            <div className="bg-white border border-slate-100 rounded-2xl p-7 shadow-sm">
              <div className="text-sm font-semibold">Request a demo</div>
              {demoSubmitMessage ? (
                <div className="mt-5 flex min-h-[320px] flex-col justify-center rounded-2xl p-8">
                  <div>
                    <div className="flex items-center gap-4">
                      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#111827] text-white shadow-sm">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      </div>
                      <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Success</div>
                    </div>

                    <div className="mt-8 min-w-0">
                      <div className="text-3xl font-semibold tracking-tight text-slate-900">Demo request sent</div>
                      <div className="mt-4 max-w-md text-base leading-relaxed text-slate-700">
                        {demoSubmitMessage}
                      </div>
                      <div className="mt-3 max-w-md text-sm leading-relaxed text-slate-600">
                        We may reply directly to the email you submitted.
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="mt-5 space-y-3">
                    <input
                      type="text"
                      value={demoForm.name}
                      onChange={(e) => handleDemoFieldChange("name", e.target.value)}
                      className="h-12 w-full rounded-xl border border-slate-200 px-4 text-slate-900 outline-none focus:ring-2 focus:ring-slate-300 focus:border-slate-300 transition"
                      placeholder="Name"
                    />
                    <input
                      type="email"
                      value={demoForm.email}
                      onChange={(e) => handleDemoFieldChange("email", e.target.value)}
                      className="h-12 w-full rounded-xl border border-slate-200 px-4 text-slate-900 outline-none focus:ring-2 focus:ring-slate-300 focus:border-slate-300 transition"
                      placeholder="Email"
                    />
                    <input
                      type="text"
                      value={demoForm.phone}
                      onChange={(e) => handleDemoFieldChange("phone", e.target.value)}
                      className="h-12 w-full rounded-xl border border-slate-200 px-4 text-slate-900 outline-none focus:ring-2 focus:ring-slate-300 focus:border-slate-300 transition"
                      placeholder="Phone"
                    />
                    <input
                      type="text"
                      value={demoForm.restaurantName}
                      onChange={(e) => handleDemoFieldChange("restaurantName", e.target.value)}
                      className="h-12 w-full rounded-xl border border-slate-200 px-4 text-slate-900 outline-none focus:ring-2 focus:ring-slate-300 focus:border-slate-300 transition"
                      placeholder="Restaurant name"
                    />
                    <textarea
                      value={demoForm.note}
                      onChange={(e) => handleDemoFieldChange("note", e.target.value)}
                      className="min-h-[108px] w-full rounded-xl border border-slate-200 px-4 py-3 text-slate-900 outline-none focus:ring-2 focus:ring-slate-300 focus:border-slate-300 transition resize-y"
                      placeholder="Notes"
                    />
                  </div>

                  <button
                    type="button"
                    onClick={submitDemoRequest}
                    disabled={!canSubmitDemo || isSubmittingDemo}
                    className={`see-in-action-demo-btn mt-5 w-full h-12 rounded-xl font-medium transition shadow-sm ${
                      (!canSubmitDemo || isSubmittingDemo) ? "opacity-70 cursor-not-allowed" : ""
                    }`}
                  >
                    {isSubmittingDemo ? "Sending..." : "Request demo"}
                  </button>

                  {demoSubmitError ? (
                    <div className="mt-4 text-sm text-[#FD7657]">{demoSubmitError}</div>
                  ) : null}

                  <div className="mt-4 text-xs text-slate-500">
                    By submitting, you agree to be contacted about EatsBits. No spam.
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-white border-t border-slate-100">
        <div className={cn("mx-auto", MAX_W, "px-4 md:px-8 py-12")}>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div>
              <div className="flex items-center gap-3">
                <Logo />
                <span className="text-lg font-semibold">EatsBits</span>
              </div>
              <div className="text-xs text-slate-500 mt-2">Trusted by modern restaurants across Texas</div>
            </div>

            <div className="flex flex-wrap gap-5 text-sm text-slate-600">
              {navItems.map((item) => (
                <button key={item.id} onClick={() => smoothScrollToId(item.id)} className="hover:text-slate-900 transition">
                  {item.label}
                </button>
              ))}
              <Link to="/privacy/" className="hover:text-slate-900 transition">
                Privacy Policy
              </Link>
              <Link to="/terms/" className="hover:text-slate-900 transition">
                Terms of Service
              </Link>
              <Link to="/merchant-fees/" className="hover:text-slate-900 transition">
                Merchant Fees
              </Link>
            </div>

            <div className="flex items-center gap-2">
              <img className="p-2 opacity-70 hover:opacity-90 transition" src={instaLogo} alt="" />
              <img className="p-2 opacity-70 hover:opacity-90 transition" src={tiktokLogo} alt="" />
              <img className="p-2 opacity-70 hover:opacity-90 transition" src={facebookLogo} alt="" />
            </div>
          </div>
          <div className="mt-8 text-center text-xs text-slate-500">
            &copy; {currentYear} EatsBits. All rights reserved.
          </div>
        </div>
      </footer>

      {/* Mobile menu: portal to body avoids #root overflow/flex stacking so hero never paints over the drawer */}
      {typeof document !== "undefined" &&
        createPortal(
          <div
            role="dialog"
            aria-modal="true"
            aria-label="Main menu"
            aria-hidden={!isMenuOpen}
            className={cn(
              "fixed inset-0 z-[200] flex min-h-[100dvh] flex-col bg-white transition-transform duration-300 ease-out lg:hidden",
              isMenuOpen
                ? "translate-x-0 pointer-events-auto"
                : "translate-x-full pointer-events-none"
            )}
          >
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
              <div className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain px-5 pt-5">
                <div className="flex shrink-0 items-center justify-between gap-2">
                  <div className="flex min-w-0 items-center gap-3">
                    <Logo />
                    <span className="text-lg font-semibold">EatsBits</span>
                  </div>
                  <button
                    type="button"
                    onClick={() => setMenuOpen(false)}
                    className="inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-lg hover:bg-slate-100"
                    aria-label="Close menu"
                  >
                    <img src={crossicon} alt="" className="h-8 w-8 object-contain" />
                  </button>
                </div>

                <div className="mt-8 pb-6">
                  <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Menu</p>
                  <div className="flex flex-col gap-1 text-slate-800">
                    {navItems.map((item) => (
                      <button
                        key={item.id}
                        type="button"
                        className="min-h-11 rounded-lg py-2 text-left text-base hover:bg-slate-50"
                        onClick={() => {
                          setMenuOpen(false);
                          setTimeout(() => smoothScrollToId(item.id), 60);
                        }}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>

                  <div className="mt-8 flex flex-wrap items-center gap-2 border-t border-slate-100 pt-6">
                    <img className="h-10 w-10 object-contain p-1" src={instaLogo} alt="" />
                    <img className="h-10 w-10 object-contain p-1" src={tiktokLogo} alt="" />
                    <img className="h-10 w-10 object-contain p-1" src={facebookLogo} alt="" />
                  </div>
                </div>
              </div>

              <div
                className="shrink-0 border-t border-slate-100 bg-white px-5 pt-4 shadow-[0_-4px_24px_rgba(0,0,0,0.06)]"
                style={{ paddingBottom: "max(1.25rem, env(safe-area-inset-bottom, 0px))" }}
              >
                <Link
                  to="/Sign-up"
                  className="inline-flex h-11 w-full items-center justify-center rounded-xl bg-[#e86a4d] font-medium text-white hover:bg-[#d45f44]"
                  onClick={() => setMenuOpen(false)}
                >
                  Sign Up
                </Link>
                <Link
                  to="/login"
                  className="mt-3 flex min-h-11 items-center justify-center text-center text-base font-medium text-slate-600"
                  onClick={() => setMenuOpen(false)}
                >
                  Login
                </Link>
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default LandingPage;
